/**
 * concoursClient — l'état du jour d'un participant au concours d'univers.
 *
 * Même danse 401 → rafraîchissement → nouvel essai que client.js (fetchAuthentifie) :
 * une session expirée se renouvelle toute seule au lieu de faire disparaître la jauge.
 * Onglet neuf : le jeton d'accès n'est pas persisté, on le reconstruit AVANT la première
 * requête (cf. rapportsClient.js), sinon elle part sans en-tête.
 */

import { API_URL, fetchAuthentifie, getAuthHeader, hasCredentials } from './client';

/**
 * @returns {Promise<{participant: boolean, nom?: string, emoji?: string,
 *   univers?: {utilises: number|null, plafond: number},
 *   depense_centimes?: {utilises: number|null, plafond: number},
 *   reecritures?: {utilises: number|null, plafond: number},
 *   remise_a_zero?: string}>}
 */
export async function lireMonEtatConcours() {
  if (!getAuthHeader() && hasCredentials()) {
    try {
      const { useAuthStore } = await import('../store/useAuthStore');
      await useAuthStore.getState().refreshAccessToken();
    } catch (_) { /* la requête ci-dessous dira ce qu'il en est */ }
  }
  const res = await fetchAuthentifie(`${API_URL}/api/concours/moi`, { cache: 'no-store' });
  if (!res.ok) {
    const err = new Error(`Concours : HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}
